module.exports = __webpack_public_path__ + "img/noavatar.4b5a0eb5.jpeg";